module.exports = __webpack_public_path__ + "static/media/ai-page-hero-1.6ddb8385.png";